import { createSlice } from '@reduxjs/toolkit';

import {
    INITIALIZE_VALUES,
    RESET,
    RESET_FORM,
    SAVE_PROJECT,
    SAVE_PROJECT_SUCCESS,
    SAVE_PROJECT_FAILURE,
    SET_IS_OPEN_MODAL,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    initialValues: {
        wind_speed: 0,
        snow_load: 0,
    },
    isOpenModal: false,
    saveProject: {
        isSaving: false,
        errors: [],
    },
};

const loadAndWindModalSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [INITIALIZE_VALUES]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [SAVE_PROJECT]: (state) => {
            state.saveProject = {
                ...state.saveProject,
                errors: [],
                isSaving: true,
            };
        },
        [SAVE_PROJECT_FAILURE]: (state, action) => {
            state.saveProject = {
                ...state.saveProject,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_PROJECT_SUCCESS]: (state, action) => {
            state.saveProject = {
                ...state.saveProject,
                data: action.payload,
                isSaving: false,
            };
        },
        [SET_IS_OPEN_MODAL]: (state, action) => {
            state.isOpenModal = action.payload;
        },
    },
});

export const loadAndWindModalActons = loadAndWindModalSlice.actions;

export default loadAndWindModalSlice.reducer;
